import React from "react";
import { PAYMENT_METHODS } from "../utils/constants";

const PaymentMethodSelect = ({ value, onChange, translations }) => {
  return (
    <select
      className="full-width"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      style={{
        direction: translations.setlang === "ar" ? "rtl" : "ltr",
        textAlign: translations.setlang === "ar" ? "right" : "left",
        width: "100%",
      }}
    >
      <option value="" disabled>
        {translations.SelectPaymentmethod}
      </option>
      {PAYMENT_METHODS.map((method) => (
        <option key={method.value} value={method.value}>
          {translations[`SelectPaymentmethod${method.label}`] || method.label}
        </option>
      ))}
    </select>
  );
};

export default PaymentMethodSelect;